const updateSessionData = (key, newValues) => {
  const stored = JSON.parse(sessionStorage.getItem(key)) || {};

  for (const property in newValues) {
    stored[property] = newValues[property];
  }

  sessionStorage.setItem(key, JSON.stringify(stored));
};

export default updateSessionData;